import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

import Table from '../../../../../../shared/components/Table'

export const StyledTable = styled(Table)`
  height: auto;
`

export const IconButtonStyle = styled(Button)`
  color: ${colors.blue};
  width: 40px;
  height: 40px;
`
